import React from 'react'
import BuyButton from 'src/components/ui/BuyButton'

import KitLook from './KitLookDetails'

type HandleMouseOverType = {
  haveVariants: boolean
  variants: Array<{
    sku: string
    name: string
    description: string
    offers: {
      lowPrice: number
      offers: Array<{
        availability: string
        price: number
        listPrice: number
        seller: {
          identifier: string
        }
      }>
    }
    additionalProperty: Array<{
      propertyID: string
      name: string
      value: number | string
      valueReference: string
    }>
  }>
  buyDisabled: boolean
  price: number
  buyProps: {
    onClick: (e: React.MouseEvent) => void
    'data-testid': string
    'data-sku': string | undefined
    'data-seller': string | undefined
  }
  linkProps: {
    to: string
    onClick: () => void
    'data-testid': string
  }
  isKit: boolean
}

export default function HandleMouseOver({
  haveVariants,
  variants,
  buyDisabled,
  price,
  buyProps,
  linkProps,
  isKit,
}: HandleMouseOverType) {
  const checkStock = (variant: {
    offers: { offers: Array<{ availability: string; price: number }> }
  }) => {
    const offersProduct = variant?.offers?.offers?.[0]

    return isKit && offersProduct?.price > 0
      ? true
      : offersProduct?.availability === 'https://schema.org/InStock'
  }

  const variantsInStock = variants?.filter(checkStock)?.length > 0

  return (
    <>
      {haveVariants || isKit ? (
        <>
          {price === 0 || !variantsInStock ? (
            <BuyButton disabled data-card-buy-button="true">
              INDISPONÍVEL
            </BuyButton>
          ) : (
            <KitLook isKit={isKit} linkProps={linkProps} />
          )}
        </>
      ) : (
        <BuyButton
          disabled={buyDisabled}
          data-card-buy-button="true"
          {...buyProps}
        >
          {price === 0 || buyDisabled ? 'INDISPONÍVEL' : 'COMPRAR'}
        </BuyButton>
      )}
    </>
  )
}
